module.exports = "/_next/static/images/BreakdownSilosBetweenTeams@2x-df79b40ae822747356a89a33ea9a683d.png";